import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { AxiomHeatStatus } from "../../models";

const axiomHeatStatusLabels: Record<Exclude<AxiomHeatStatus, null>, string> = {
  F: "FAIL",
  C: "HOLD C",
  T: "HOLD T",
  B: "HOLD B",
};

interface AxiomHeatStatusChipProps {
  status: AxiomHeatStatus;
  size?: "small" | "medium";
}

export const AxiomHeatStatusChip = ({
  status,
  size = "small",
}: AxiomHeatStatusChipProps) => {
  const theme = useTheme();

  if (!status) return null;

  const label = axiomHeatStatusLabels[status];
  const heatStatusColors = theme.palette.billetYard.heatStatus;

  const colorMap = {
    F: heatStatusColors.fail,
    C: heatStatusColors.chemistry,
    T: heatStatusColors.tags,
    B: heatStatusColors.both,
  };

  const colors = colorMap[status];

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        height: size === "small" ? "18px" : "24px",
        fontSize: size === "small" ? "12px" : "13px",
        fontWeight: 600,
        backgroundColor: colors.background,
        color: colors.text,
        borderRadius: "4px",
        "& .MuiChip-label": {
          padding: size === "small" ? "0 4px" : "0 8px",
        },
      }}
    />
  );
};
